export default __webpack_public_path__ + "static/media/feedback.465343cd.png";